import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, CanActivateFn, CanDeactivate, CanLoad, Route, Router, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { LocalStorageService } from './LocalStorageService';
import { AuthService } from '../public/services/auth.service';
import { JWTTokenServiceService } from '../public/services/token.service';

Injectable({
    providedIn: 'root'
  })
  
  export const AuthGuard: CanActivateFn = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree => {

    const router: Router = inject(Router);
    var tokenService:JWTTokenServiceService = inject(JWTTokenServiceService);
    
    if (tokenService.isTokenExpired() == false && tokenService.getToken()) {
      return true;    
    }
    router.navigate(['login'])
    return false;
  }
